import { stringifyBytes } from 'components/modules/files/services/files';

export const DOC_UPLOAD_MAX_SIZE = 5242880; // 5 MB default
export const MAX_SIZE_EXCEEDED_MESSAGE = `Max document or image size of ${stringifyBytes(
  DOC_UPLOAD_MAX_SIZE,
)} was exceeded by files:`;
export const MAX_SIZE_EXCEEDED_SUGGESTION_MESSAGE = `We suggest compressing and re-uploading these files using a tool like`;
export const MAX_DOC_SIZE_EXCEEDED_SUGGESTION_URL = `https://www.compress2go.com/`;
